
  <!-- Setting modal -->
  <div id="ModalPopUPMaster" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelForMaster }} </h4>
          <button type="button" class="closed ml-auto" data-dismiss="modal" style="color: white">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12" style="height: 500px; padding: 0px">
          <div [innerHtml]="ModuleMasterData"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- Password Modal -->
  <div id="ModalPopUPIFrameCommunity" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-CommunityProfile" [style.width.%]="width">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 id="modal-header" class="Heading">{{ ModelForCommunity }}</h4>
          <button type="button" class="closed ml-auto" (click)="this[CallFunctionOnCloseModalCommunity]()"
            data-dismiss="modal" style="color: white">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <iframe data.attributes width="100%" [height]="height" frameBorder="0"
            [src]="modalURLCommunity | safe"></iframe>
        </div>
      </div>
    </div>
  </div>

  <aside class="sidebar" [class.collapsed]="!sidebarExpanded()">
    <button class="toggle-btn position-absolute" (click)="toggleSidebar()">
      @if(sidebarExpanded()){
      <i class="fa-solid fa-chevron-right"></i>
      } @else{
      <i class="fa-solid fa-chevron-left"></i>
      }
    </button>
    <div class="nav-container">
      <nav class="sidebar-nav">
        <ul>
          <li class="nav-item">
            <a class="my-3 menu-item" [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
              [class.active]="activeRoute == '/dashboard'" routerLink="/dashboard">
              <mat-icon>dashboard</mat-icon>
              <span>Dashboard </span>
            </a>
          </li>
          <li class="nav-item">
            <a [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'" data-bs-toggle="collapse"
              aria-expanded="false" aria-controls="quickActions" data-bs-target="#quickActions"
              class="my-3 menu-item nav-link" [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
              <mat-icon>flash_on</mat-icon>
              <span>Quick Actions</span>
              @if (sidebarExpanded()) {
              <i class="fa fa-chevron-down ms-auto"></i>
              }
            </a>
            <div
              [ngClass]="isActive('/plan/') || isActive('/nav/notice/') || isActive('/nav/case/') || isActive('/viewdiary') || isActive('/navorgcon/0/0') ? '' : 'collapse'"
              id="quickActions">
              <ul class="flex-column border-bottom sub-item">
                <li class="nav-item">
                  <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="decision" data-bs-target="#decision"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                    class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                    <mat-icon fontSet="material-symbols-outlined">gavel</mat-icon>
                    <span>Decision </span>
                    @if (sidebarExpanded()) {
                    <i class="fa fa-chevron-down ms-auto"></i>
                    }
                  </a>
                  <div [ngClass]="isActive('/plan/') ? '' : 'collapse'" id="decision">
                    <ul class="flex-column border-bottom">
                      <li class="nav-item ">
                        <a class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/plan/plan/0'" routerLink="/plan/plan/0"
                          (click)="selectedMenu = 'DecisionListing'">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="Decision Listing">format_list_numbered</mat-icon>
                          <span class="break-line">Decision Listing </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/plan/process/0'" routerLink="/plan/process/0"
                          (click)="selectedMenu = 'pendingDecision'">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="Pending Listing">pending_actions</mat-icon>
                          <span class="break-line">Pending Decision </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="notice" data-bs-target="#notice"
                    class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                    <mat-icon fontSet="material-symbols-outlined">list_alt</mat-icon>
                    <span>Notice </span>
                    @if (sidebarExpanded()) {
                    <i class="fa fa-chevron-down ms-auto"></i>
                    }
                  </a>
                  <div [ngClass]="isActive('/nav/notice/') ? '' : 'collapse'" id="notice">
                    <ul class="flex-column border-bottom sub-item">
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="noticeListing"
                          data-bs-target="#noticeListing" class="my-1 ml-2 menu-item nav-link"
                          [class.active]="activeRoute == '/nav/notice/0/update'" routerLink="/nav/notice/0/update"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="Notice Listing">format_list_numbered</mat-icon>
                          <span class="break-line">Notice Listing </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" class="my-1 ml-2 menu-item nav-link"
                          [class.active]="activeRoute == '/nav/notice/0/process'" routerLink="/nav/notice/0/process"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="Notice Listing">pending_actions</mat-icon>
                          <span class="break-line">Pending Notice </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="case" data-bs-target="#case"
                    class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                    <mat-icon fontSet="material-symbols-outlined">cases</mat-icon>
                    <span>Case </span>
                    @if (sidebarExpanded()) {
                    <i class="fa fa-chevron-down ms-auto"></i>
                    }
                  </a>
                  <div id="case" [ngClass]="isActive('/nav/case/') ? '' :'collapse'">
                    <ul class="flex-column border-bottom sub-item">
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="caseListing"
                          data-bs-target="#caseListing" class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/nav/case/0/update'" routerLink="/nav/case/0/update">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="Case Listing">format_list_numbered</mat-icon>
                          <span class="break-line">Case Listing </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/nav/case/0/process'" routerLink="/nav/case/0/process">
                          <mat-icon fontSet="material-symbols-outlined" title="Notice Case">pending_actions</mat-icon>
                          <span class="break-line">Pending Case </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="deleteCase"
                          data-bs-target="#deleteCase" class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/nav/case/0/DuplicateDelete'"
                          routerLink="/nav/case/0/DuplicateDelete">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="Delete Duplicate case">delete_forever</mat-icon>
                          <span class="break-line">Delete Duplicate case </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="finalVerdict"
                    data-bs-target="#finalVerdict" class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                    <i class="fa-solid fa-gavel"></i>
                    <span>Final Verdict </span>
                    @if (sidebarExpanded()) {
                    <i class="fa fa-chevron-down ms-auto"></i>
                    }
                  </a>
                  <div [ngClass]="isActive('/nav/case/0/UpdateFinalVerdict') ? '' : 'collapse'" id="finalVerdict">
                    <ul class="flex-column border-bottom sub-item">
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="listOfProcessedCase"
                          data-bs-target="#listOfProcessedCase" class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/nav/case/0/UpdateFinalVerdict'"
                          routerLink="/nav/case/0/UpdateFinalVerdict">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="List of Processed Case">format_list_numbered</mat-icon>
                          <span class="break-line">List of Processed Case </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="diary" data-bs-target="#diary"
                    class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                    <mat-icon fontSet="material-symbols-outlined">menu_book</mat-icon>
                    <span>Diary </span>
                    @if (sidebarExpanded()) {
                    <i class="fa fa-chevron-down ms-auto"></i>
                    }
                  </a>
                  <div [ngClass]="isActive('/viewdiary') ? '' : 'collapse'" id="diary">
                    <ul class="flex-column border-bottom sub-item">
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="viewDiary"
                          data-bs-target="#viewDiary" class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/viewdiary'" routerLink="/viewdiary">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="View Diary">format_list_numbered</mat-icon>
                          <span class="break-line">View Diary </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="contacts" data-bs-target="#contacts"
                    class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'">
                    <mat-icon fontSet="material-symbols-outlined">contacts</mat-icon>
                    <span>Contacts </span>
                    @if (sidebarExpanded()) {
                    <i class="fa fa-chevron-down ms-auto"></i>
                    }
                  </a>
                  <div [ngClass]="isActive('/navorgcon/0/0') ? '' : 'collapse'" id="contacts">
                    <ul class="flex-column border-bottom sub-item">
                      <li class="nav-item">
                        <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="viewcontacts"
                          data-bs-target="#viewcontacts" class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="activeRoute == '/navorgcon/0/0'" routerLink="/navorgcon/0/0">
                          <mat-icon fontSet="material-symbols-outlined"
                            title="View contacts">format_list_numbered</mat-icon>
                          <span class="break-line">View contacts </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'" data-bs-toggle="collapse"
              aria-expanded="false" aria-controls="Report" data-bs-target="#Report" class="my-3 menu-item nav-link"
              [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'" class="my-3 menu-item" title="Report">
              <mat-icon>description</mat-icon>
              <span>Report</span>
              @if (sidebarExpanded()) {
              <i class="fa fa-chevron-down ms-auto"></i>
              }
            </a>
          </li>
          <div class="collapse" id="Report">
            <ul class="flex-column border-bottom sub-item">
              <li class="nav-item">
                <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="DecisionReports"
                  data-bs-target="#DecisionReports" class="my-1 ml-2 menu-item nav-link"
                  [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                  [class.active]="selectedMenu == 'DecisionReports'" title="Decision Report">
                  <mat-icon>description</mat-icon>
                  <span>Decision Reports</span>
                  @if (sidebarExpanded()) {
                  <i class="fa fa-chevron-down ms-auto"></i>
                  }
                </a>
                <div class="collapse" id="DecisionReports">
                  <ul class="flex-column border-bottom">
                    @if (ReportData?.length > 0 ){
                    <ng-container *ngFor="let report of ReportData">
                      <li class="nav-item" *ngIf="report.MainDescr == 'Decision Reports'">
                        <a data-toggle="modal" data-target="#ReportModalPopUP" [title]="report.SubDescr"
                          (click)="OpenFlow( '85',report.FlowID,report.Link,'2',report.SubDescr);isModalPopUp = true;selectedMenu = report.SubDescr"
                          class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="selectedMenu == report.SubDescr">
                          <mat-icon>description</mat-icon>
                          @if (sidebarExpanded()) {
                          <span class="text-ellipsis">{{ report.SubDescr }}</span>
                          }
                        </a>
                      </li>
                    </ng-container>
                    }
                  </ul>
                </div>
              </li>
              <li class="nav-item">
                <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="NoticeReports"
                  data-bs-target="#NoticeReports" class="my-1 ml-2 menu-item nav-link"
                  [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                  [class.active]="selectedMenu == 'NoticeReports'" href="/plan/plan/0" title="Notice Report">
                  <mat-icon>description</mat-icon>
                  <span>Notice Reports</span>
                  @if (sidebarExpanded()) {
                  <i class="fa fa-chevron-down ms-auto"></i>
                  }
                </a>
                <div class="collapse" id="NoticeReports">
                  <ul class="flex-column border-bottom">
                    @if (ReportData?.length > 0) {
                    <ng-container *ngFor="let report of ReportData">
                      <li class="nav-item" *ngIf="report.MainDescr == 'Notice Reports'">
                        <a data-toggle="modal" data-target="#ReportModalPopUP" [title]="report.SubDescr"
                          [title]="report.SubDescr"
                          (click)="OpenFlow( '85',report.FlowID,report.Link,'3',report.SubDescr);isModalPopUp = true;selectedMenu = report.SubDescr"
                          class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="selectedMenu == report.SubDescr">
                          <mat-icon>description</mat-icon>
                          @if (sidebarExpanded()) {
                          <span class="text-ellipsis">{{ report.SubDescr }}</span>
                          }
                        </a>
                      </li>
                    </ng-container>
                    }
                  </ul>
                </div>
              </li>
              <li class="nav-item">
                <a data-bs-toggle="collapse" aria-expanded="false" aria-controls="CaseReports"
                  data-bs-target="#CaseReports" class="my-1 ml-2 menu-item nav-link"
                  [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                  [class.active]="selectedMenu == 'CaseReports'" href="/plan/plan/0" title="Case Report">
                  <mat-icon>description</mat-icon>
                  <span>Case Reports</span>
                  @if (sidebarExpanded()) {
                  <i class="fa fa-chevron-down ms-auto"></i>
                  }
                </a>
                <div class="collapse" id="CaseReports">
                  <ul class="flex-column border-bottom">
                    @if (ReportData?.length > 0) {
                    <ng-container *ngFor="let report of ReportData">
                      <li class="nav-item" *ngIf="report.MainDescr == 'Case Reports'">
                        <a data-toggle="modal" data-target="#ReportModalPopUP"
                          (click)="OpenFlow( '85',report.FlowID,report.Link,'4',report.SubDescr);isModalPopUp = true;selectedMenu = report.SubDescr"
                          class="my-1 ml-2 menu-item nav-link"
                          [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                          [class.active]="selectedMenu == report.SubDescr">
                          <mat-icon>description</mat-icon>
                          @if (sidebarExpanded()) {
                          <span class="text-ellipsis">{{ report.SubDescr }}</span>
                          }
                        </a>
                      </li>
                    </ng-container>
                    }
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <li class="nav-item">
            <a [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'" data-bs-toggle="collapse"
              aria-expanded="false" aria-controls="configuration" data-bs-target="#configuration"
              class="my-3 menu-item nav-link">
              <mat-icon>settings</mat-icon>
              <span>Configuration</span>
              @if (sidebarExpanded()) {
              <i class="fa fa-chevron-down ms-auto"></i>
              }
            </a>
            <div [ngClass]="isActive('/notification') || isActive('/escalation') ? '' : 'collapse'" id="configuration">
              <ul class="flex-column border-bottom sub-item">
                <li class="nav-item">
                  <a class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                    [class.active]="activeRoute == '/notification'" routerLink="/notification">
                    <mat-icon>notifications</mat-icon>
                    <span>Notification</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="my-1 ml-2 menu-item nav-link"
                    [ngClass]="sidebarExpanded() ? '' : 'justify-content-center large'"
                    [class.active]="activeRoute == '/escalation'" routerLink="/escalation">
                    <mat-icon fontSet="material-symbols-outlined">escalator</mat-icon>
                    <span>Escalation</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
      <nav class="sidebar-nav">
        <hr style="border: 1px solid #E5E7EB">
        <ul>
          <li>
            <a class="my-3"
              [class.active]="isActive('/general-master') || isActive('/user-master') || isActive('/navcompany/company') || isActive('/system')"
              data-toggle="modal" (click)="OpenModalMaster('108', 'Settings')" data-target="#ModalPopUPMaster">
              <i class="fas fa-cogs" [ngClass]="sidebarExpanded() ? '' : 'fa-xl ms-3'"></i>
              <span>Settings</span>
            </a>
          </li>
          <li>
            <a class="my-3" href="https://redleafsoftwares.com/welcome/contact" target="_blank">
              <i class="fas fa-question-circle" [ngClass]="sidebarExpanded() ? '' : 'fa-xl ms-3'"></i>
              <span>Help</span>
            </a>
          </li>
          <li>
            <a class="my-3" (click)="logoutConfirmation()">
              <i class="fas fa-sign-out-alt" [ngClass]="sidebarExpanded() ? '' : 'fa-xl ms-3'"></i>
              <span>Logout</span>
            </a>
          </li>
          <!-- @for (item of footerMenuItems; track $index) { -->
          <!-- <li>
          <a class="my-3" [class.active]="item.active" (click)="onClickMenu(item)" [routerLink]=" item.route ? item.route : null" [href]="item.isExternal ? item.route : null" [target]="item.isExternal ? item.target : null">
            <i class="fas fa-{{ item.icon }}" [ngClass]="expanded ? '' : 'fa-xl ms-3'"></i>
            <span>{{ item.label }}</span>
          </a>
        </li> -->
          <!-- } -->
        </ul>
      </nav>
    </div>
  </aside>
  <div class="main-container" [class.expanded]="sidebarExpanded()"
    [ngStyle]="sidebarExpanded() ? { 'padding-left': '200px','padding-top': '70px' } : { 'padding-left': '70px','padding-top': '70px' }">
    <header class="topbar">
      <div class="container-fluid d-flex align-items-center  px-4">
        <div class="sidebar-header d-flex align-items-center justify-content-center">
          <img src="../../assets/images/logo-praticaone.png" style="height: 55px;" alt="PraticaOne" />
        </div>

        <div class="user-area d-flex align-items-center gap-3 ms-auto">
          <a class="notify-card decision" routerLink="/plan/process/0" title="Pending Decision">
              <mat-icon>gavel</mat-icon>
              <span class="badge">{{ PendingDecision ?? 0 }}</span>
              <!-- <small>Decision</small> -->
            </a>

            <a class="notify-card notice" routerLink="/nav/notice/0/process" title="Pending Notice">
              <mat-icon>list_alt</mat-icon>
              <span class="badge">{{ PendingNotice ?? 0 }}</span>
              <!-- <small>Notice</small> -->
            </a>

            <a class="notify-card case" routerLink="/nav/case/0/process" title="Pending Case">
              <mat-icon>folder</mat-icon>
              <span class="badge">{{ PendingCase ?? 0 }}</span>
              <!-- <small>Cases</small> -->
            </a>

            <a class="notify-card verdict" routerLink="/nav/case/0/UpdateFinalVerdict" title="Pending Final Verdict">
              <i class="fa-solid fa-gavel"></i>
              <span class="badge">{{ PendingFinalVerdict ?? 0 }}</span>
              <!-- <small>Verdict</small> -->
            </a>

            <a class="notify-card diary" routerLink="/viewdiary" title="Pending Diary">
              <mat-icon>menu_book</mat-icon>
              <span class="badge">{{ PendingDiary ?? 0 }}</span>
              <!-- <small>Diary</small> -->
            </a>
          <!-- <div class="notification">
            <a  title="Pending My FeedBack">
              <i class="fa-solid fa-message"></i>
              <span class="badge">{{ PendingMyFeedBack ?? 0 }}</span>
            </a>
          </div> 
          <div class="notification">
            <a [href]="AlertLink">
              <i class="fas fa-bell"></i>
              <span class="badge">{{ TodayAlert ?? 0 }}</span>
            </a>
          </div>
          <div class="notification">
            <a [href]="AlertLinkMyFeedBack">
              <i class="fa-solid fa-message"></i>
              <span class="badge">{{ TodayAlertFinalVerdict ?? 0 }}</span>
            </a>
          </div>
          <div class="notification">
            <a [href]="AlertLinkMyFeedBack">
              <i class="fa-solid fa-chart-simple"></i>
              <span class="badge">{{ TodayAlertMyFeedBack ?? 0 }}</span>
            </a>
          </div> -->
          <li class="nav-item dropdown d-none d-xl-inline-flex user-dropdown">
            <a class="nav-link dropdown-toggle" id="UserDropdown" href="#" data-bs-toggle="dropdown"
              aria-expanded="false">
              <img class="img-xs rounded-circle ms-2" src="assets/images/faces/profile.jpg" alt="Profile image" />
              <span class="font-weight-bold text-black"> {{ UserName }} <i class="fa-solid fa-caret-down"></i> </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown"
              style="translate: -77px;">
              <div class="dropdown-header text-center">
                <img class="img-md rounded-circle" src="assets/images/faces/profile.jpg" alt="Profile image"
                  style="width: 60px;" />
                <p class="mb-1 mt-3 cursor-pointer text-black link" data-toggle="modal"
                  (click)="OpenModalIFrameCommunity()" data-target="#ModalPopUPIFrameCommunity" style="cursor: pointer">
                  {{ UserName }}
                </p>
                <p class="font-weight-light text-muted mb-0 menu-title">
                  {{ email }}
                </p>
              </div>
              <a class="dropdown-item" data-toggle="modal" (click)="OpenModalProfile('profile', 'My Profile')"
                data-target="#ModalPopUPIFrameCommunity"><i class="dropdown-item-icon icon-user text-primary"></i>
                <p>My Profile</p>
              </a>
              <!-- <a class="dropdown-item"
                ><i class="dropdown-item-icon icon-speech text-primary"> </i>
                <p>Messages</p>
              </a>
              <a class="dropdown-item"
                ><i class="dropdown-item-icon icon-energy text-primary"> </i>
                <p>Activity</p>
              </a> -->
              <a class="dropdown-item" href="https://redleafsoftwares.com/welcome/contact" target="_blank"><i
                  class="dropdown-item-icon icon-question text-primary"> </i>
                <p>FAQ</p>
              </a>
              <a class="dropdown-item" data-toggle="modal" (click)="OpenModalPass('setpassword', 'Set Password')"
                data-target="#ModalPopUPIFrameCommunity"><i class="dropdown-item-icon icon-question text-primary"> </i>
                <p>Password</p>
              </a>
              <a data-toggle="modal" (click)="logoutConfirmation()" class="dropdown-item"><i
                  class="dropdown-item-icon icon-power text-primary"> </i>
                <p>Sign Out</p>
              </a>
            </div>
          </li>
        </div>
      </div>
    </header>
    <!-- <app-topbar (toggleSidebar)="toggleSidebar()" /> -->
    <main class="content"
      [ngStyle]="sidebarExpanded() ? {'width' : 'calc(100vw - 200px)'} : {'width' : 'calc(100vw - 70px)'}">
      <router-outlet name="masterpage"></router-outlet>
      <!--   <div class="main-panel">
    <div class="content-wrapper">
      <my-placeholder name="navigation"></my-placeholder>
      <my-placeholder name="main"></my-placeholder>
    </div>
  </div> -->
    </main>
  </div>

<!-- </html> -->
<!-- Logout Confirmation Modal -->

<div data-backdrop="static" class="modal fade" id="logoutModal" tabindex="-1" aria-labelledby="logoutModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content logout-modal">
      <div class="modal-header">
        <h3 class="modal-title" id="logoutModalLabel">
          <i class="fa fa-sign-out-alt mr-2"></i> Confirm Logout
        </h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body text-center">
        <i class="fa fa-question-circle text-warning mb-3" style="font-size: 40px"></i>
        <p>Are you sure you want to logout from your account?</p>
      </div>

      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-secondary px-4" data-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-danger px-4" data-dismiss="modal" (click)="confirmLogout()">
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- modal-Module-Start -->
<ng-container *ngIf="isModalPopUp">
  <div id="ReportModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelFor }}</h4>
          <br />
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="isModalPopUp = false">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group" style="overflow-y: auto; height: 500px; padding: 0px">
          <div *ngIf="this.MsgType == 2">
            <div *ngFor="let flow of FlowData" class=" col-sm-12 mb-3">
              <a class="navigation-link" routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/0" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Decision <i class="fa fa-external-link"
                    aria-hidden="true"></i> </span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 7">
            <div *ngFor="let flow of FlowData" class=" col-sm-12 mb-3">
              <a class="navigation-link" routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/0" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Library <i class="fa fa-external-link"
                    aria-hidden="true"></i></span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 3">
            <div class="row">
              <!-- <div class="col-sm-4"></div> -->
              <div class="col-sm-6 d-flex pb-4 ps-4 mx-auto text-center">
                <label class="radio-inline navigation-link radio-btn"><input type="radio" Name="NoticeSent"
                    (click)="onItemChange('1')" value="1" checked />Sent</label>
                <label class="radio-inline navigation-link radio-btn"><input type="radio" Name="NoticeSent"
                    (click)="onItemChange('0')" value="0" />Received</label>
                <label class="radio-inline navigation-link radio-btn"><input type="radio" Name="NoticeSent"
                    (click)="onItemChange('2')" value="2" />All</label>
              </div>
              <!-- <div class="col-sm-4"></div> -->
            </div>
            <div *ngFor="let flow of FlowData" class=" col-sm-12 mb-3">
              <a class="navigation-link" routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/HLPNoticeType~{{
                  RadioValue
                }}" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Notice <i class="fa fa-external-link"
                    aria-hidden="true"></i></span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 4">
            <div class="row">
              <div class=" col-sm-6 d-flex pb-4 ps-4 mx-auto text-center">
                <label class="radio-inline navigation-link radio-btn"><input type="radio" Name="CaseSent"
                    (click)="onItemChange('1')" value="1" checked />Filed By Us</label>
                <label class="radio-inline navigation-link radio-btn"><input type="radio" Name="CaseSent"
                    (click)="onItemChange('0')" value="0" />Against Us</label>
                <label class="radio-inline navigation-link radio-btn"><input type="radio" Name="CaseSent"
                    (click)="onItemChange('2')" value="2" />All</label>
                <!-- <label class="radio-inline navigation-link"><input type="radio" Name="CaseSent" (click)="onItemChange('3')"
                                          value="2">E-Court</label> -->
              </div>
            </div>
            <div *ngFor="let flow of FlowData" class=" col-sm-12 mb-3">
              <a class="navigation-link" routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/HLPNoticeType~{{
                  RadioValue
                }}" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Case <i class="fa fa-external-link"
                    aria-hidden="true"></i></span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 1">
            <div class="col-sm-4">
              <div class="moduleHeading">Decision Reports</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <div class="module-card">
                    <a class="navigation-link"
                      (click)="OpenFlow('85', ReportName.FlowID, ReportName.Link, '2', ReportName.SubDescr)">
                      <span>
                        <img src="assets/resources/images/Report.png" class="imgicon" />
                        {{ ReportName.SubDescr }}
                      </span>
                      <i class="fa fa-external-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="moduleHeading">Notice Reports</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Notice Reports'">
                      <tr>
                        <td>
                          <div class="col-sm-2">
                            <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                            &nbsp;&nbsp;
                          </div>
                          <div class="col-sm-10">
                            <a (click)="
                                OpenFlow(
                                  '85',
                                  ReportName.FlowID,
                                  ReportName.Link,
                                  '3',
                                  ReportName.SubDescr
                                )
                              ">
                              {{ ReportName.SubDescr }}
                            </a>
                          </div>
                        </td>
                      </tr>
                    </div>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="moduleHeading">Case Reports</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Case Reports'">
                      <tr>
                        <td>
                          <div class="col-sm-2">
                            <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                          </div>
                          <div class="col-sm-10">
                            <a (click)="
                                OpenFlow(
                                  '85',
                                  ReportName.FlowID,
                                  ReportName.Link,
                                  '4',
                                  ReportName.SubDescr
                                )
                              ">
                              {{ ReportName.SubDescr }}
                            </a>
                          </div>
                        </td>
                      </tr>
                    </div>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.MsgType == 0">
            <div [innerHtml]="ModuleData"></div>
          </div>
          <div *ngIf="this.MsgType == 6">
            <div class="col-sm-6" [innerHtml]="ModuleData"></div>
            <div class="col-sm-6">
              <div class="moduleHeading">Reports<br />&nbsp;</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Report'">
                      <div class="col-sm-2">
                        <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                        &nbsp;&nbsp;
                      </div>
                      <div class="col-sm-10">
                        <a (click)="
                            OpenFlow(
                              '85',
                              ReportName.FlowID,
                              ReportName.Link,
                              '7',
                              ReportName.SubDescr
                            )
                          ">
                          {{ ReportName.SubDescr }}
                        </a>
                      </div>
                    </div>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- modal-Module-End -->